import React from "react";
import { motion } from "framer-motion";

const mapUrl = "https://maps.app.goo.gl/YZPuv7T5pLMiMoqaA";
const embedUrl =
  "https://www.google.com/maps?q=Cyber%20Meadows%20Kondapur%20Hyderabad&output=embed";

export default function LocationCyber() {
  return (
    <section className="cyber-location-section" id="woods-location">
      <motion.div 
        className="cyber-location-map"
        initial={{ opacity: 0, y: 45 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.6 }}
      >
        <iframe
          title="Vessella Cyber Meadows location"
          src={embedUrl}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      </motion.div>

      <motion.div 
        className="cyber-location-card"
        initial={{ opacity: 0, y: 45 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut", delay: 0.2 }}
        viewport={{ once: true, amount: 0.6 }}
      >
        <span className="cyber-location-eyebrow">Location</span>
        <h2>Cyber Meadows</h2>
        <p>
          Set in Kondapur with quick access to Hyderabad&apos;s IT corridor,
          everyday conveniences, and key city routes.
        </p>
        <a href={mapUrl} target="_blank" rel="noopener noreferrer">
          View on Google Maps
        </a>
      </motion.div>
    </section>
  );
}
